import createTableStore from "ds/components/Table/store/useTableStore";

import {
  TEMPLATE_DEPLOYMENTS_COLUMN_CONFIG,
  TEMPLATE_DEPLOYMENTS_COLUMNS_STORAGE_KEY,
} from "./constants";

const useTemplateDeploymentsTableStore = createTableStore({
  storageKey: TEMPLATE_DEPLOYMENTS_COLUMNS_STORAGE_KEY,
  config: TEMPLATE_DEPLOYMENTS_COLUMN_CONFIG,
});
export default useTemplateDeploymentsTableStore;
